import React, { useState } from 'react';
import AlmeSurveyDialog from './AlmeSurveyDialog';
import Button from 'syf-component-library/ui/atoms/Button/Button';
import styled from 'styled-components';
import { StateIcon } from '../AlmeUtilities/Icons/StyledIcon';
import { createSurveyAppEventParams } from './AlmeSurveyModel';
const AlmeSurveyCard = styled.div `
  background-color: #e6e6e6;  
  border-radius: 4px;  
  width: auto;
  height:auto;
  min-height:40px;
  display: flex;
  margin: 15px 0 0 20px;
  padding: 4px 8px;
  align-items: center;
`;
const StyledButtonDiv = styled.div `
display: flex;
& > span {
    margin: 10px 0 0 10px;
    display:inline-block;
}
`;
const StyledButton = styled(Button) ` 
    font-weight: ${(props) => props.selected ? 'bold' : 'normal'};
    text-transform: uppercase;
    display: flex;
    align-items: center;
    &:disabled {
        text-decoration: none;
    }
    & > span {
        margin: 0 0 0 5px;
        display:inline-block;
    }
`;
export function getSurveyResponseAction(response) {
    if (!response.responseActions)
        return null;
    else {
        for (const action of response.responseActions) {
            if (action.Name === "InlineSurvey")
                return action;
        }
        return null;
    }
}
const AlmeSurvey = (props) => {
    var _a;
    const [surveyState, setSurveyState] = useState(() => ({ disabled: !props.isLastResponse, showSurveyDialog: false, yesSelected: false, noSelected: false }));
    const focusProps = {
        disabled: surveyState.disabled || ((_a = props.focusProps) === null || _a === void 0 ? void 0 : _a.disabled),
    };
    const historyYesSelected = props.fromHistory && sessionStorage.getItem(`${props.entryId}`) === 'yesSelected' ? true : false;
    const historyNoSelected = props.fromHistory && sessionStorage.getItem(`${props.entryId}`) === 'noSelected' ? true : false;
    const handleYesClick = () => {
        setSurveyState(Object.assign(Object.assign({}, surveyState), { disabled: true, yesSelected: true }));
        sessionStorage.setItem(`${props.entryId}`, "yesSelected");
        const surveyParams = createSurveyAppEventParams(props.responseAction.MetaData.InlineSurveyLinks.Yes.parameters, props.responseAction.SurveyUnitLabel, props.entryId);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        props.onSendFormAppEvent('GradingComplete', surveyParams, 'External');
    };
    const handleNoClick = () => {
        setSurveyState(Object.assign(Object.assign({}, surveyState), { showSurveyDialog: true }));
        sessionStorage.setItem(`${props.entryId}`, "noSelected");
        props.setIsDialogOpen(true);
    };
    const submitSurvey = (isSurveyCancelled, input) => {
        const surveyParams = createSurveyAppEventParams(isSurveyCancelled
            ? props.responseAction.MetaData.Survey.NoSurvey.Footer.CancelLink.parameters
            : props.responseAction.MetaData.Survey.NoSurvey.Footer.SubmitLink.parameters, props.responseAction.SurveyUnitLabel, props.entryId);
        surveyParams.gradingReason = input || "";
        setSurveyState(Object.assign(Object.assign({}, surveyState), { disabled: true, noSelected: true, showSurveyDialog: false }));
        props.setIsDialogOpen(false);
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        props.onSendFormAppEvent('GradingComplete', surveyParams, 'External');
    };
    const ariaPressedYes = props.fromHistory ? historyYesSelected : surveyState.yesSelected;
    const ariaPressedNo = props.fromHistory ? historyNoSelected : surveyState.noSelected;
    return (React.createElement("div", null,
        React.createElement(AlmeSurveyCard, null,
            React.createElement(StyledButtonDiv, { role: "group", "aria-labelledby": "groupLabel" },
                React.createElement("span", { id: "groupLabel" }, props.responseAction.MetaData.InlineSurveyLinks.Title),
                React.createElement(StyledButton, Object.assign({ buttonType: "text", id: 'alme-survey-yes-button', "data-testid": "yes-button", "aria-pressed": ariaPressedYes, selected: ariaPressedYes, onClick: handleYesClick }, focusProps, { ariaLabel: props.responseAction.MetaData.InlineSurveyLinks.Yes.DisplayText }),
                    React.createElement(StateIcon, { size: 16, selected: ariaPressedYes, iconType: "ThumbUpIconLight" }),
                    React.createElement("span", null, props.responseAction.MetaData.InlineSurveyLinks.Yes.DisplayText)),
                React.createElement(StyledButton, Object.assign({ buttonType: "text", id: 'alme-survey-no-button', "data-testid": "no-button", "aria-pressed": ariaPressedNo, selected: ariaPressedNo, onClick: handleNoClick }, focusProps, { ariaLabel: props.responseAction.MetaData.InlineSurveyLinks.No.DisplayText }),
                    React.createElement(StateIcon, { size: 16, selected: ariaPressedNo, iconType: "ThumbDownIconLight" }),
                    React.createElement("span", null, props.responseAction.MetaData.InlineSurveyLinks.No.DisplayText)))),
        React.createElement(AlmeSurveyDialog, { inputMetaData: props.responseAction.MetaData.Survey.NoSurvey, isOpen: surveyState.showSurveyDialog, onSubmitSurvey: submitSurvey })));
};
export default AlmeSurvey;
